/**
 * Audit log enums - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 */
export const auditActionLabels = {
    create: 'Create',
    update: 'Update',
    delete: 'Delete',
    restore: 'Restore',
    read: 'Read',
    export: 'Export',
};
export const auditActionValues = Object.keys(auditActionLabels);
export const auditActorTypeLabels = {
    user: 'User',
    patient: 'Patient',
    system: 'System',
    job: 'Job',
    platform_admin: 'Borradh support',
};
export const auditActorTypeValues = Object.keys(auditActorTypeLabels);
/** Fixed categories keep patient details out of access reasons and telemetry. */
export const platformAccessReasonLabels = {
    clinic_support: 'Clinic support request',
    incident_review: 'Security or service incident',
    service_check: 'Service health check',
};
export const platformAccessReasonValues = Object.keys(platformAccessReasonLabels);
//# sourceMappingURL=audit.js.map